












































































































































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {mapGetters} from "vuex";
import TiptapSns from "@/components/timeline/_tiptapSns.vue";
import TiptapBlog from "@/components/timeline/_tiptapBlog.vue";
import moment from "moment";
import ImageUploaderBtn from "@/components/timeline/post/_imageUploaderBtn.vue";
import VideoUploaderBtn from "@/components/timeline/post/_videoUploaderBtn.vue";
import AudioUploaderBtn from "@/components/timeline/post/_audioUploaderBtn.vue";
import {User} from "@/types";

import Messages from "@/components/pages/user/Messages.vue";
import {AxiosError, AxiosResponse} from "axios";
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import Toast from "@/script/message";
import {forEach} from "lodash";

@Component({
    computed: {...mapGetters(["user"])},
    components: {
        Messages,
        ImageUploaderBtn,
        TiptapSns,
        TiptapBlog,
        VideoUploaderBtn,
        AudioUploaderBtn,
        Swiper,
        SwiperSlide,
    },
})
export default class Post extends Vue {
    toast = new Toast();
    feed: any = {};
    isEditorEmpty: boolean = true;
    youtubeLink: string[] = [];

    communityList: any[] = [];
    isChannelOn: boolean = false;
    communities: string = "Communities";
    channels: string = "Channels";

    // 첨부파일
    imgPreviewArr: any[] = [];
    videoSrc: any = {};
    audioPreviewArr: any[] = [];

    user!: User;
    // follow 공개 여부
    isPrivate: boolean = false;
    isScheduledPost: boolean = false;
    time: any = 0;

    selectedCommunityId: number = -1;
    selectedChannelId: number = -1;

    // 예약 포스팅
    minDate = new Date();
    reserved_date: string = "";
    reserved_time: string = "";

    //community
    isCommunityClick: boolean = false;

    selectedCommunity: any = "";
    selectedCategory: any[] = [];

    attFiles: any[] = [];
    updateImgArr: any = [];
    updateAudioArr: any = [];
    updateVideo: any = {};

    textPreview: any = "";
    userTag: string = "";

    activeTab: string = "SNS";
    sliderValue = 200
    MPIswiperOption = {
        pagination: {
            el: '.swiper-pagination'
        },
        slidesPerView: 4,
        spaceBetween: 10,
        breakpoints: {
            300: {
                slidesPerView: 3
            },
            480: {
                slidesPerView: 4
            },
            768: {
                slidesPerView: 4
            },
            992: {
                slidesPerView: 4
            },
            1200: {
                //slidesPerView: 7
            }
        }
    }

    MPCswiperOption = {
        slidesPerView: 'auto',
        spaceBetween: 5,
    }

    // 해시태그 멘션
    private hasTagSuggestion: boolean = false;
    private postedHashtag: string[] = [];

    async mounted() {

        await this.$store.dispatch("loginState");
        if (this.$store.getters.feed) {
            this.feed = this.$store.getters.feed
            this.prefill();
        }
        // this.fetch();
    }

    beforeDestroy() {
        this.init()
        this.$emit('reMount')

    }

    prefill() {
        this.activeTab = this.feed.post_type;
        const attachFiles = Array.isArray(this.feed.attatchment_files) ? this.feed.attatchment_files : JSON.parse(this.feed.attatchment_files)
        if (attachFiles) {
            this.$store.dispatch('resetAttFiles')
            for (const file of attachFiles) {
                if (this.activeTab === 'SNS') {
                    if (file.type === 'image') {
                        this.$store.commit('imgArr', file)
                    }
                    else if (file.type === 'sound') {
                        this.$store.commit('audioArr', file)
                    }
                    else if (file.type === 'video') {
                        this.$store.commit('videoArr', file)
                    }

                }
                else if (this.activeTab === 'BLOG') {

                    if (file.type === 'image') {
                        this.$store.commit('blogImgArr', file)
                    }
                    else if (file.type === 'sound') {
                        this.$store.commit('blogAudioArr', file)
                    }
                    else if (file.type === 'video') {
                        this.$store.commit('blogVideoArr', file)
                    }
                    // console.log("blogAudioArr", this.$store.getters.blogAudioArr)
                    // console.log("blogVideoArr", this.$store.getters.blogVideoArr)
                    // console.log("blogImgArr", this.$store.getters.blogImgArr)
                }

            }
        }
        this.$store.commit('postContents', this.feed.content);

    }

    fetch() {
        const obj = {
            user_id: this.user.id,
            sort: 'ALPAHBETIC'
        }
        this.$api.joinedCommunityList(this.user.id)
            .then((res: any) => {
                this.communityList = res;
                console.log(res)
            })
            .catch((err: AxiosError) => {

            })
    }

    init() {
        this.selectedCategory = [];
        this.videoSrc = "";
        this.imgPreviewArr = [];
        this.audioPreviewArr = [];
        this.$store.dispatch("resetEditor");
    }

    isActive(type: string) {
        if (!this.user) {
            this.$modal.show('needLogin')
        }
        else {
            this.isPostEmpty() ? this.activeTab = type : this.$modal.show('alertModal');
            // this.isEditorEmpty = true
        }

    }

    isPostEmpty() {
        if (
            this.attFiles.length !== 0 ||
            !this.isEditorEmpty ||
            this.$store.getters.imgArr.length > 0 ||
            this.$store.getters.audioArr.length > 0
            || this.feed.content
            // || !(Object.keys(this.feed).length === 0)
        ) {
            // console.log(this.attFiles.length !== 0)
            // console.log(this.isEditorEmpty)
            // console.log(this.$store.getters.imgArr.length)
            // console.log(this.$store.getters.audioArr.length)
            return false;
        }
        else {
            return true;
        }
    }

    leavePost(state: boolean) {
        if (state) {
            if (this.activeTab === 'SNS') {
                this.activeTab = 'BLOG'
            }
            else {
                this.activeTab = 'SNS'
            }
            this.init();
        }

        this.$modal.hide('alertModal')
    }

    hideModal() {
        this.$store.dispatch('resetEditor')
        this.$modal.hide('modalPost')
    }

    //포스팅 업로드
    async uploadPost() {
        this.attFiles = [];
        let date = this.reserved_date + "T" + this.reserved_time;
        let scheduledTime = moment(date).valueOf();

        if (this.activeTab === 'BLOG') {
            if (this.$store.getters.blogImgArr.length > 0) {
                for (let i = 0; i < this.$store.getters.blogImgArr.length; i++) {
                    if (!this.$store.getters.postContents.includes(`"attr-img" src="${this.$store.getters.blogImgArr[i].url}"`)) {
                        this.$store.getters.blogImgArr.splice(i, 1)
                    }
                }
                this.attFiles.push(...this.$store.getters.blogImgArr)
            }
            if (this.$store.getters.blogVideoArr.length > 0) {
                for (let i = 0; i < this.$store.getters.blogVideoArr.length; i++) {
                    if (!this.$store.getters.postContents.includes(`<iframe src="${this.$store.getters.blogVideoArr[i].url}"`)) {
                        this.$store.getters.blogVideoArr.splice(i, 1)
                    }
                }
                this.attFiles.push(...this.$store.getters.blogVideoArr)
            }
            if (this.$store.getters.blogAudioArr.length > 0) {

                for (let i = 0; i < this.$store.getters.blogAudioArr.length; i++) {
                    if (!this.$store.getters.postContents.includes(`src="${this.$store.getters.blogAudioArr[i].url}"`)) {
                        this.$store.getters.blogAudioArr.splice(i, 1)
                    }
                }
                this.attFiles.push(...this.$store.getters.blogAudioArr)
            }
        }
        else {
            this.attFiles = await this.uploadAtt();
        }
        if (this.$store.getters.postContents.length === 0) {
            this.$modal.show('minChar')
        }
        else {
            const obj = {
                user_uid: this.user.uid,
                post_state: this.activeTab,
                attatchment_files: this.attFiles,
                post_contents: this.$store.getters.postContents,
                visibility: this.isPrivate ? "PRIVATE" : "PUBLIC",
                hashtags: [],
                // user_tagId: this.$store.getters.userTagList,
                user_tag: [
                    // {
                    //     id: 111,
                    //     nickname: "followers"
                    // },
                ],
                game_id: "",
                channel_id: this.user.channel_id,
                ...this.$store.getters.currPage,
                // portfolio_ids: [
                // ],
                scheduled_for: null
            }

            this.$api.uploadPost(obj)
                .then((res: AxiosResponse) => {
                    this.$emit('reFetch')
                    this.toast.successToast(`${this.$t('posting.done')}`)
                })
                .catch((err: AxiosError) => {
                    this.toast.failToast(`${this.$t('posting.fail')}`)
                })
                .finally(() => {
                    this.$modal.hide("modalPost");
                    this.init();
                    this.$store.commit('postContents', '')
                })
        }


    }


    //포스팅 수정
    async updatePost() {

        // if (this.activeTab === 'BLOG') {
        //     if (this.$store.getters.blogImgArr) {
        //         // for (let i = 0; i < this.$store.getters.blogImgArr.length; i++) {
        //         //     if (!this.$store.getters.postContents.includes(`"attr-img" src="${this.$store.getters.blogImgArr[i].url}"`)) {
        //         //         this.$store.getters.blogImgArr.splice(i, 1)
        //         //     }
        //         // }
        //         this.attFiles.push(this.$store.getters.blogImgArr)
        //     }
        //     if (this.$store.getters.blogVideoArr) {
        //         // for (let i = 0; i < this.$store.getters.blogVideoArr.length; i++) {
        //         //     if (!this.$store.getters.postContents.includes(`<iframe src="${this.$store.getters.blogVideoArr[i].url}"`)) {
        //         //         this.$store.getters.blogVideoArr.splice(i, 1)
        //         //     }
        //         // }
        //         this.attFiles.push(this.$store.getters.blogVideoArr)
        //     }
        //     if (this.$store.getters.blogAudioArr) {
        //
        //         // for (let i = 0; i < this.$store.getters.blogAudioArr.length; i++) {
        //         //     if (!this.$store.getters.postContents.includes(` src="${this.$store.getters.blogAudioArr[i].url}"`)) {
        //         //         this.$store.getters.blogAudioArr.splice(i, 1)
        //         //     }
        //         // }
        //         this.attFiles.push(this.$store.getters.blogAudioArr)
        //     }
        // }
        // else {
        this.attFiles = await this.uploadAtt();
        // }
        // console.log('this.attFiles', this.attFiles)
        // console.log('this.$store.getters.blogAudioArr', this.$store.getters.blogAudioArr)
        // console.log('this.updateAudioArr', this.updateAudioArr)
        if (this.updateImgArr.length > 0) {
            this.attFiles.unshift(...this.updateImgArr)
        }
        if (this.updateAudioArr.length > 0) {
            this.attFiles.unshift(...this.updateAudioArr)
        }
        if (Object.keys(this.updateVideo).length !== 0) {
            this.attFiles.unshift(this.updateVideo)
        }

        //todo: 백엔드 수정후 변경
        if (this.$store.getters.postContents.includes('<audio')) {
            this.attFiles.push({
                priority: 0,
                url: 'audio',
                type: 'sound'
            })
        }
        if (this.$store.getters.postContents.includes('<iframe')) {
            this.attFiles.push({
                priority: 0,
                url: 'video',
                type: 'video'
            })

        }
        if (this.$store.getters.postContents.includes('<img')) {
            this.attFiles.push({
                priority: 0,
                url: 'image',
                type: 'image'
            })
        }


        const obj = {
            post_id: this.feed.id,
            user_uid: this.user.uid,
            post_state: this.activeTab,
            attatchment_files: this.attFiles,
            post_contents: this.$store.getters.postContents,
            visibility: this.isPrivate ? "PRIVATE" : "PUBLIC",
            hashtags: [],
            // user_tagId: this.$store.getters.userTagList,
            // user_tagId:'123',
            game_id: "",
            channel_id: this.user.channel_id,
            ...this.$store.getters.currPage,
            portfolio_ids: [""],
            scheduled_for: null
        }

        this.$api.updatePost(obj)
            .then((res: AxiosResponse) => {
                this.$emit('reFetch')
                this.toast.successToast(`${this.$t('posting.edit.done')}`)
            })
            .catch((err: AxiosError) => {
                this.toast.failToast(`${this.$t('posting.edit.fail')}`)
            })
            .finally(() => {
                this.init();
                this.$modal.hide("modalPost");
                this.$store.commit('postContents', '')
            })
    }


    editorState(state: boolean) {
        this.isEditorEmpty = state;
    }


    /**
     * 첨부파일
     * */
    @Watch('$store.getters.imgArr')
    imgArr() {
        this.imgPreviewArr = this.$store.getters.imgArr

    }

    @Watch('$store.getters.audioArr')
    audioArr() {
        this.audioPreviewArr = this.$store.getters.audioArr
    }

    @Watch('$store.getters.videoArr')
    watchImg() {
        this.videoSrc = this.$store.getters.videoArr
    }

    deletePreviewImg(idx: number) {
        this.$store.getters.imgArr.splice(idx, 1)
        this.imgPreviewArr = this.$store.getters.imgArr
    }

    deleteVideo() {
        this.videoSrc = "";
    }

    deleteAudio(idx: number) {
        this.$store.getters.audioArr.splice(idx, 1)
    }

    async uploadAtt() {
        const imgFiles: any = [];
        const audioFiles: any = [];

        this.$store.getters.imgArr.forEach((img) => {
            if (img.file) {
                imgFiles.push(img)
            }
            else {
                this.updateImgArr.push(img)
            }
        })

        this.$store.getters.audioArr.forEach((audio) => {
            if (audio.file) {
                audioFiles.push(audio)
            }
            else {
                this.updateAudioArr.push(audio)
            }
        })

        const formData = new FormData();

        for (let i = 0; i < imgFiles.length; i++) {
            formData.append(imgFiles[i].file.name, imgFiles[i].file);
        }

        for (let i = 0; i < audioFiles.length; i++) {
            formData.append(audioFiles[i].file.name, audioFiles[i].file);
        }


        if (this.videoSrc.file) {
            formData.append(this.videoSrc.file.name, this.videoSrc.file)
        }
        else {
            this.updateVideo = this.videoSrc;
        }

        if (formData) {
            return await this.$api.fileUploader(formData)
        }

    }

    resetAttr(isReset: boolean) {
        if (isReset) {
            this.$store.dispatch('resetAttFiles')
        }
        this.$modal.hide('alertAttrModal')


    }

    /**
     * 예약 포스팅
     * */

    @Watch("reserved_time")
    watchTime(time: Date) {
        let today = moment().format("yyyy-MM-DD");
        let currentTime = moment().format("HH:MM:SS");
        let newTime = moment().add(1, "h").format("HH:MM:SS");

        if (today === this.reserved_date) {
            if (currentTime >= this.reserved_time) {
                alert("현재시간 이전은 선택이 불가능합니다.");
                this.reserved_time = newTime;
            }
        }
    }

    /**
     * 포스팅 카테고리 선택
     * */
    // select category
    selectCommunity(e) {
        let selectedItem = e.target.value;
        if (selectedItem.toLowerCase() === "communities") {
            this.isChannelOn = false;
        }
        else {
            this.isChannelOn = true;
            // this.channelList = this.$api.getCommunityInfo(
            //     selectedItem.id
            // ).channels;
        }
        this.communities = selectedItem.name;
        this.selectedCommunityId = selectedItem.id;
    }

    selectChannel(selectedItem: any) {
        this.channels = selectedItem.name;
        this.selectedChannelId = selectedItem.id;
        // console.log(selectedItem);
    }

    getChannel(channel) {
        this.selectedCommunity = Object.assign(this.selectedCommunity, {
            channel: channel,
        });

        this.selectedCategory.push(this.selectedCommunity);
    }

    getCommunity(community) {
        this.selectedCommunity = community;
    }

    deleteCategory(idx: number) {
        this.selectedCategory.splice(idx, 1);
    }
}
